export const STRING_ONLY_ATTRIBUTE_CODES = ['category_id'];
